import axios from './axios'

export const member = (params) => axios.get('/management/distribution/statistics/member', { params })
export const newMember = (params) => axios.get('/management/distribution/statistics/new-member', { params })
export const customer = (params) => axios.get('/management/distribution/statistics/customer', { params })
export const queryByDay = (params) => axios.get('/management/distribution/statistics/day-member', { params })
export const memberByDay = (params) => axios.get('/management/distribution/statistics/day-member', { params })
export const customerByDay = (params) => axios.get('/management/distribution/statistics/day-customer', { params })
export const rank = params => axios.get('/management/distribution/statistics/rank', { params })
